module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "SOM",
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('h1', {
    staticClass: "SOM_titre",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre2"
    }
  }, [_vm._v("Series preface")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre3"
    }
  }, [_vm._v("Author’s preface")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre4"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1"
    }
  }, [_vm._v("1 Introduction")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv1-001"
    }
  }, [_vm._v("Defining biblical theology")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv1-002"
    }
  }, [_vm._v("Defining our biblical-theological topic")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv1-003"
    }
  }, [_vm._v("Past research on the biblical theology of repentance")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2"
    }
  }, [_vm._v("2 Repentance in the Torah")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#niv1-004"
    }
  }, [_vm._v("Genesis")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#niv1-005"
    }
  }, [_vm._v("Exodus")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#niv1-006"
    }
  }, [_vm._v("Leviticus")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#niv1-007"
    }
  }, [_vm._v("Numbers")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#niv1-008"
    }
  }, [_vm._v("Deuteronomy")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#niv1-009"
    }
  }, [_vm._v("Summary")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 Repentance in the Former Prophets")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Joshua")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Judges")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Samuel")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kings")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summary")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Repentance in the Latter Prophets: penitential process")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Repentance in the Latter Prophets: Isaiah")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Isaiah 1 – 39")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Isaiah 40 – 55")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Isaiah 56 – 66")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summary")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Repentance in the Latter Prophets: Jeremiah and Ezekiel")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv1-019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jeremiah")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv1-020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jeremiah 1 – 23")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv1-021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jeremiah 26 – 52")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv1-022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ezekiel")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv1-023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ezekiel 4 – 33")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv1-024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ezekiel 33 – 48")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv1-025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summary")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 Repentance in the Latter Prophets: the Twelve")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv1-026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hosea")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv1-027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Joel")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv1-028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Amos")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv1-029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jonah")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv1-030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Micah")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv1-031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nahum–Zephaniah")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv1-032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Haggai")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv1-033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zechariah")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv1-034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Malachi")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv1-035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summary")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 Repentance in the Writings: wisdom and worship")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8#niv1-036",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Job")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8#niv1-037",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Proverbs")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8#niv1-038",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalms")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8#niv1-039",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summary")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 Repentance in the Writings: exile and restoration")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9#niv1-040",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lamentations")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9#niv1-041",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Daniel")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9#niv1-042",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ezra–Nehemiah")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9#niv1-043",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summary")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 Repentance in the Writings: Chronicles")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10#niv1-044",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("David as exemplary penitent (1 Chr. 21)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10#niv1-045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Solomon as promoter of repentance (2 Chr. 6 – 7)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10#niv1-046",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Solomon’s penitential vision realized (2 Chr. 10 – 36)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10#niv1-047",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summary")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 Repentance in Old Testament theology")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv1-048",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dimensions of repentance")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv1-049",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Motivation for repentance")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv1-050",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Purpose of repentance")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv1-051",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sociology of repentance")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv1-052",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psychology of repentance")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv1-053",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Divine disablement")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv1-054",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Divine enablement")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv1-055",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Repentance in redemptive history: exile and restoration")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv1-056",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 Repentance in the New Testament")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12#niv1-057",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Synoptic Gospels and Acts")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12#niv1-058",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gospel of John")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12#niv1-059",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epistles")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12#niv1-060",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Revelation")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12#niv1-061",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summary")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 Repentance in New Testament theology")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13#niv1-062",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Repentance in redemptive history: restoring the kingdom")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13#niv1-063",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dimensions of repentance")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13#niv1-064",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Motivation for repentance")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13#niv1-065",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Purpose of repentance")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13#niv1-066",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sociology of repentance")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13#niv1-067",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psychology of repentance")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13#niv1-068",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Divine disablement")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13#niv1-069",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Divine enablement")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13#niv1-070",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 Theological implications of repentance")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14#niv1-071",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beginning the journey")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14#niv1-072",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Continuing the journey")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen1"
  }, [_c('span', {
    attrs: {
      "href": "#/appen5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index of authors")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index of Scripture references")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index of ancient sources")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for "), _c('i', [_vm._v("Return to Me")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/fin_acheve",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029e4e6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sommaire.vue
// module id = 66
// module chunks = 0